<template>
  <div id="edr-footer">
    <hr>
    <footer>
      <p>
        This website, the EDR plugin, and the EDR discord bot are neither official tools for the game <a href="https://elitedangerous.com" target="_blank" rel="noopener">Elite: Dangerous</a>, nor affiliated with Frontier Developments.
      </p>
      <p>
        All product names and logos, registered trademarks are the properties of their respective owners.
      </p>
      <p>
        EDR - ED Recon &copy; 2018-{{ new Date().getFullYear() }}<br>
        <router-link to="/manual">MANUAL (PDF)</router-link> | <router-link to="/privacy-policy">PRIVACY POLICY</router-link> | <router-link to="/tos">TERMS OF SERVICE</router-link> | <a href="mailto:edreconyt@blippy.gmail.com" v-on:click="properEmail">CONTACT</a>
      </p> 
    </footer>
  </div>
</template>

<style>
#edr-footer {
  text-align: center;
}
hr {
  border-color: #833a01;
}
footer {
  color: #aaaaaa;
  font-size: 0.8em;
}
footer a {
  color: #eeeeee;
}
</style>

<script>
export default {
  name: 'EdrFooter',
  methods: {
    properEmail: function(event) {
        var href = event.target.getAttribute('href');
        event.target.setAttribute('href', href.replace('blippy.', ''));
        return false;
    }
  }
}
</script>
